import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import { catchError, filter, finalize, switchMap, take } from "rxjs/operators";
import { IError } from "src/app/models/ierror.interface";
import { AuthService } from "src/app/services/auth/auth.service";
import { MessageToastService } from "src/app/services/common/message-toast.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private _auth: AuthService;

  constructor(
    private _router: Router,
    private _msg: MessageToastService,
    private injector: Injector) {
    this._auth = this.injector.get(AuthService);
   }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(catchError((error) => {
        if (error) {
          switch (error.status) {
            case 401: {
             return  this.Error401Handler(request, next);
            }
            case 400: {
             return  this.Error400Handler(request, next, error);
            }
            case 403: {
              return this.Error403Handler(request, next, error);
            }
            case 404: {
              return this.Error404Handler(request, next, error);
            }
            default: {
              return this.ErrorDefaultHandler(request, next, error);
            }
          }
        } else {
          return throwError(error);
        }
      }));
  }

  Error401Handler(request: HttpRequest<any>, next: HttpHandler) {
    console.log(401);
    if (!this._auth.token)
    {
      console.log('no refresh token');
      this._auth.logOut();
      return of(null);
    }

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this._auth.refreshToken().pipe(
        switchMap((token: any) => {
          if (token) {
            this.isRefreshing = false;
            this.refreshTokenSubject.next(token);
            return next.handle(this.addToken(request, this._auth.token));
          } else {
            this.isRefreshing = false;
            console.log('[logout] interceptor');
            this._auth.logOut();
            return of(null);
          }
        }),
        catchError(error => {
          this._auth.logOut();
          return throwError(error);
        }),
        finalize(() => this.isRefreshing = false));
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null && token !== undefined),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
  Error400Handler(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
    console.log(400);
    console.log(error);
    const err = error.error as IError;
    this._msg.errorEx(error?.error);
    if (error.error === 'invalid_grant' || err.message === 'invalid_grant') {
      this._msg.error("Не удалось войти");
      return of(null);
    }
    return of(null);
  }

  Error404Handler(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
    console.log(404);
    this._msg.error("Не найдено");
    return of(null);
  }
  Error403Handler(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
    console.log(403);
    this._msg.error("Доступ запрещен");
    return of(null);
  }

  ErrorDefaultHandler(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
    console.log('def');
    console.log(error);
    this._msg.errorEx(error.error);
    return of(null);
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }
}
